import { render, staticRenderFns } from "./share.vue?vue&type=template&id=64eb87dc&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"
import style0 from "./share.vue?vue&type=style&index=0&id=64eb87dc&prod&scoped=true&lang=less"
import style1 from "./share.vue?vue&type=style&index=1&id=64eb87dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb87dc",
  null
  
)

export default component.exports